import './index.css'
import { WATERMARKING } from '@disco/constants/billing-provider-components'
import { PLAN_ACTIVE } from '@disco/constants/FeatureTypes'
import { useEnableChangeAddOns } from '@disco/state-management/selectors/addOns'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { getSubscription } from '@disco/state-management/selectors/subscription'
import { getWatermarkingQuota } from '@disco/utils/getWatermarkingQuota'

import React from 'react'
import { useSelector } from 'hooks/use-redux'
import AddOns from './AddOns'

const AddOnsContainer = (): React.ReactNode => {
  // @TODO SUB-543 : Consolidate a lot of these into AddOns.tsx
  const user = useSelector(state => state.user)
  const subscription = useSelector(getSubscription)
  const { address, address_2, city, country, state, zip } = subscription ?? {}
  const userId = user?.id
  const businessId = user?.business?.id
  const seatsAndTracks = useSelector(state => state.seatsAndTracks)
  const { quota, quotaUsed, quotaUnlimited } = useSelector(getWatermarkingQuota)
  const enableChangeAddOns = useEnableChangeAddOns({})
  const disabled = !useFeatureEnabled(PLAN_ACTIVE) && !Boolean(quota)
  const quotaUpdating = seatsAndTracks?.items[WATERMARKING]
  return (
    <AddOns
      quota={quotaUnlimited ? Infinity : quota ?? 0}
      quotaUsed={quotaUsed}
      quotaUpdating={Boolean(quotaUpdating)}
      unsubscribeAvailable={Boolean(quota)}
      disabled={disabled}
      disabledUpdatePaymentDetails={
        !user.permissions?.includes('can_change_business_settings') ||
        !subscription?.subscription_id
      }
      type={WATERMARKING}
      enableWM={Boolean(quota)}
      enableChange={enableChangeAddOns}
      contactInformation={{
        address,
        address_2,
        city,
        country,
        state,
        zip,
        reference: `${businessId}-${userId}`,
      }}
    />
  )
}

export default AddOnsContainer
